import { useBlogsHook } from "../useBlogsHook";

export default function BlogSelector() {
    const {
        selectedBlogPage,
        setSelectedBlogPage,
    } = useBlogsHook();

    return (
        <div className='my-8 flex justify-center items-center flex-col'>
            <p className='text-2xl font-normal mb-4'>Manage Blogs</p>
            <p className='text-lg font-light mb-4'>Select an action to perform on Blogs</p>
            <div className='flex justify-between items-center my-4'>
                <div className='flex justify-end items-center'>
                    <button
                        onClick={() => setSelectedBlogPage(1)}
                        className='bg-blue-400 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>List Blogs</button>
                    <button
                        onClick={() => setSelectedBlogPage(2)}
                        className='bg-green-500 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>Add New Blog</button>
                    <button
                        onClick={() => setSelectedBlogPage(3)}
                        className='bg-yellow-500 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>Update Blog</button>
                    <button
                        onClick={() => setSelectedBlogPage(4)}
                        className='bg-red-500 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>Delete Blog</button>
                </div>
            </div>
        </div>
    )
}
